import {Component} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {ConsentService} from '../service/consent.service';
import {ConsentType} from '../model/ConsentAudit';
import { ConfigService } from '../service/config.service';

@Component({
    templateUrl: 'finzy-bolt-consents.component.html',
    styleUrls: ['finzy-bolt-consents.component.scss']
})
export class FinzyBoltConsentsComponent {
    public shouldShowLoader = false;
    private readonly consentService: ConsentService;
    private readonly configService: ConfigService;
    private readonly matDialogRef: MatDialogRef<FinzyBoltConsentsComponent>;

    constructor(matDialogRef: MatDialogRef<FinzyBoltConsentsComponent>, consentService: ConsentService, configService:ConfigService) {
        this.matDialogRef = matDialogRef;
        this.consentService = consentService;
        this.configService = configService;
    }

    async onConsentGranted(): Promise<void> {
        this.showLoader();
        try {
            await this.consentService.saveConsent(ConsentType.LENDER_LOAN_AGREEMENT_REVIEWED);
            this.matDialogRef.close(true);
        } finally {
            this.hideLoader();
        }
    }

    showLoader(): void {
        this.shouldShowLoader = true;
    }

    hideLoader(): void {
        this.shouldShowLoader = false;
    }

    public getFileUrlByName(fileName):string{
        return this.configService.getPolicyFileUrlByName(fileName);
    }
}
